import { useCallback, useEffect, useState } from 'react';
import { Spinner } from 'react-bootstrap';
import IconifyIcon from '../../../wrappers/IconifyIcon';
import {
  getSafegoldCashBalance,
  parseSafegoldCashBalance,
} from '../../../../services/trading';

const REFRESH_MS = 30 * 60 * 1000;

const formatInr = (value) =>
  `₹${Number(value).toLocaleString('en-IN', {
    maximumFractionDigits: 2,
    minimumFractionDigits: 0,
  })}`;

const SafegoldWalletBalance = () => {
  const [balance, setBalance] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchBalance = useCallback(async () => {
    try {
      const res = await getSafegoldCashBalance();
      if (res && res.success === false) {
        console.warn('[SafeGold wallet] cash-balance error payload:', res);
        setBalance(null);
        setError(res.message || res.code || 'Unavailable');
        return;
      }
      const parsed = parseSafegoldCashBalance(res);
      if (parsed == null) {
        console.warn('[SafeGold wallet] Unexpected cash-balance response:', res);
        setBalance(null);
        setError('Unexpected response');
      } else {
        setBalance(parsed);
        setError(null);
      }
    } catch (err) {
      console.warn('[SafeGold wallet] cash-balance fetch failed:', err?.response?.status, err?.response?.data || err?.message);
      setError(err?.response?.data?.message || err?.message || 'Failed to load');
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchBalance();
  }, [fetchBalance]);

  useEffect(() => {
    const id = setInterval(fetchBalance, REFRESH_MS);
    const onFocus = () => fetchBalance();
    window.addEventListener('focus', onFocus);
    return () => {
      clearInterval(id);
      window.removeEventListener('focus', onFocus);
    };
  }, [fetchBalance]);

  const title = error
    ? `SafeGold wallet: ${error}`
    : balance != null
      ? `SafeGold wallet balance: ${formatInr(balance)}`
      : 'Loading SafeGold wallet balance';

  return (
    <div className="topbar-item px-2" title={title}>
      <div className="safegold-wallet-balance d-flex align-items-center gap-2">
        <IconifyIcon icon="bx:wallet" className="fs-18 text-primary" />
        <div className="d-none d-md-flex flex-column lh-sm">
          <span className="text-muted small">SafeGold wallet</span>
          {loading && balance == null && !error ? (
            <Spinner animation="border" size="sm" className="align-self-start" />
          ) : (
            <span className={error ? 'fw-semibold text-muted' : 'fw-semibold'}>
              {balance != null ? formatInr(balance) : '—'}
            </span>
          )}
        </div>
        <span className={`d-md-none ${error ? 'fw-semibold text-muted' : 'fw-semibold'}`}>
          {loading && balance == null && !error
            ? '…'
            : balance != null
              ? formatInr(balance)
              : '—'}
        </span>
      </div>
    </div>
  );
};

export default SafegoldWalletBalance;
